import {SampleRate} from "@app/strain/config/sample-rates/models/sample-rate.model";
import {MeasuringEquipment} from "@app/strain/config/measuring-equipment/models/measuring-equipment.model";
import {RiskClass} from "@app/strain/config/risk-classes/models/risk-class.model";
import {StrainTestType} from "@app/strain/common/models/enum/strain-test-type.enum";
import {StrainExecutionMode} from "@app/strain/common/models/enum/strain-execution-mode.enum";
import {StrainMeasurementGageMountingModel} from "@app/strain/common/models/view-measurement-models/strain-measurement-gage-mounting.model";
import {StrainMeasurementGageDetailsModel} from "@app/strain/common/models/view-measurement-models/strain-measurement-gage-details.model";
import {StrainMeasurementChartModel} from "@app/strain/common/models/view-measurement-models/strain-measurement-chart.model";
import {StrainMeasurementImage} from "@app/strain/common/models/view-measurement-models/strain-measurement.image";

export class StrainMeasurementDetailsModel {
    public frequency: SampleRate;
    public measuringEquipment: MeasuringEquipment;
    public processResponsible: string;
    public riskClass: RiskClass;
    public measurementType: StrainTestType;
    public temperature: number;
    public humidity: number;
    public measurementMethod: StrainExecutionMode;
    public strainResultGageMounting: StrainMeasurementGageMountingModel;
    public charts: StrainMeasurementChartModel[];
    public images: StrainMeasurementImage[];
    public isInitialMeasurement: boolean;

    constructor(measurementDetails: any = {}) {
        this.frequency = measurementDetails.frequency ? new SampleRate(measurementDetails.frequency) : null;
        this.riskClass = measurementDetails.riskClass ? new RiskClass(measurementDetails.riskClass) : null;
        this.measuringEquipment = measurementDetails.measuringEquipment ?
            new MeasuringEquipment(measurementDetails.measuringEquipment) : null;
        this.processResponsible = measurementDetails.processResponsible;
        this.measurementType = measurementDetails.measurementType;
        this.temperature = measurementDetails.temperature;
        this.humidity = measurementDetails.humidity;
        this.measurementMethod = measurementDetails.measurementMethod;
        this.strainResultGageMounting = measurementDetails.strainResultGageMounting ?
            new StrainMeasurementGageMountingModel(measurementDetails.strainResultGageMounting) : null;
        this.charts = measurementDetails.charts ? measurementDetails.charts.map(item => new StrainMeasurementChartModel(item)) : [];
        this.images = measurementDetails.images ? measurementDetails.images.map(item => new StrainMeasurementImage(item)) : [];
        this.isInitialMeasurement = measurementDetails.isInitialMeasurement;
    }
}
